
import {Controller as GroupController} from './../../../zviz2/zviz/components/group';
import BigCircle from './bigcircle';
// import SmallCircle from './smallcircle';
// import Label from './label';
import {PublicInterface as PackInterface} from './../blueprint';
import {extend, cloneObject} from './../../../zviz2/zviz/functions';
import Vector2 from './../../../zviz2/zviz/math/vector2';
import {calculatePosition} from './../functions';
import state from './../../../zviz2/zviz/state';
import {formatNumber} from './../../../tools';
import SvgImage from './../../../zviz2/zviz/components/svg/image';


class BubController extends GroupController{

    constructor(parent, blueprint){
        super(parent, blueprint);
        this.name = 'bubbleGroup';
        this.isHover = false;

        this.packCtrl = null;
        this.labelShortened = false;
        this.labelHeight = 15;
        
    }

    init(renderer){
        this.packCtrl = this.getByUid(this.blueprint.properties.data.packUid);// PackInterface.factory(this.blueprint.properties.data.packUid);
        super.init(renderer);
    }

    getChildren(){

        let data = this.blueprint.private;
        let children = [];

        if(data.counter > 0){
            data.counter--;
            calculatePosition(data);
            this.update();
        }
        children.push(this.getCircle(BigCircle, data));
        // if(data.counter == 0){
        //     for(let c of data.children){
        //         children.push(this.getCircle(SmallCircle, c));
        //     }
        //     children.push(this.getLabel(data));
        //     if(this.data.showValueOnHover && this.isHover && ! this.labelShortened && this.valueFits()){
        //         children.push(this.getValue(data ));
        //     }
        // }

        children.push(extend({
            properties: {
                attributes: {
                    'xlink:href': data.icon,
                    x: '-30px',
                    y: '-30px',
                    width: '60px',
                    height: '60px'
                }
            }
        }, SvgImage));
        
        return children;
    }


    getCircle(blueprint, data){
        return extend({
            properties: {
                data: {
                    r: data.r,
                    position: data.position,
                    color: data.color,
                    hover: this.isHover,
                    active: (state.get('filter.theme') == data.id),
                    opacity: this.getOpacity()
                }
            }
        }, blueprint);
    }


    setHover(isHover){
        this.isHover = isHover;
        if(! isHover){
            state.set('tooltip', null); // because mouseout event of text is not always captured
        }else{
            let data = this.blueprint.private;
            state.set('tooltip', ['*'+data.name, '']);
        }
        this.update();
    }


    getOpacity(){
        let opacity = this.data.opacity;
        if(this.packCtrl && this.packCtrl.isHover){
            opacity = this.isHover? 1: 0.5*this.data.opacity;
        }
        return this.isHover? 1: opacity;
    }


}



let BupBlueprint = {
    type: BubController,
    properties: {
        transform: {
            position: {
                x: (ctrl) => (ctrl.blueprint.private.position.x),
                y: (ctrl) => (ctrl.blueprint.private.position.y)
            }
        },
        data: {
            packUid: 'pack',
            dimension: 'dimension',
            id: '',
            name: 'item',
            value: 0,
            opacity: 1,
            showValueOnHover: false
        },
        style: {
            opacity: (ctrl) => (ctrl.getOpacity()),
            cursor: 'pointer'
        }
    },

    private: {
        id: '',
        r: 10,
        color: 'rgba(255,255,255,0)',
        name: '',
        type: '',
        speed: new Vector2(),
        position: new Vector2(),
        children: [],
        siblings: [],
        counter: 0
    },

    events: {
        mouseover: (event, ctrl) => { ctrl.setHover(true) },
        mouseout: (event, ctrl) => { ctrl.setHover(false) },
        click: (event, ctrl) => { state.set('filter.' + ctrl.data.dimension, ctrl.data.id); }
    },

    children: [
        (ctrl) => ( ctrl.getChildren() )
    ],

    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.packCtrl, 
                [ctrl, ctrl.update], 'hover') ),
    ]

};



export default BupBlueprint;
export {BupBlueprint as Blueprint};